export const MAPBOX = {
    search: "/search/geocode/v6/forward",
    geocoding: "/search/geocode/v6/reverse"
  };
  